<div class="general-info-card">
    <div class="mortality-header">
        <div class="status-indicators">
            <span class="birds-count">{{
                (mortality?.remaningChicks ?? 0) + ' birds'
            }}</span>
            <span class="age-indicator"
                >Age:
                {{ mortality?.age || placement?.parentStockAge || ' -' }}
                days</span
            >
        </div>
        <div class="date-time">
            {{ mortality?.date | date: 'yyyy-MM-dd' }} |
            {{ mortality?.date | date: 'HH:mm' }}
        </div>
    </div>

    <div class="mortality-grid">
        <div class="grid-item">
            <div class="field-label">Cause:</div>
            <div class="field-value">
                {{ mortality?.typeName || '-' }}
            </div>
        </div>

        <div class="grid-item">
            <div class="field-label">Partition:</div>
            <div class="field-value">
                {{ mortality?.partitionName || '-' }}
            </div>
        </div>

        <div class="grid-item">
            <div class="field-label">Farm House:</div>
            <div class="field-value">{{ mortality?.farmHouseName || '-' }}</div>
        </div>

        <div class="grid-item">
            <div class="field-label">Mortality Count:</div>
            <div class="field-value">
                {{ mortality?.numberOfChicks || '-' }}
                {{ mortality?.numberOfChicks === 1 ? 'bird' : 'birds' }}
            </div>
        </div>

        <div class="grid-item">
            <div class="field-label">Recorded By:</div>
            <div class="field-value">
                {{ mortality?.userName || '-' }}
            </div>
        </div>

        <div class="grid-item">
            <div class="field-label">Placement:</div>
            <div class="field-value">
                {{ mortality?.placementName || '-' }}
            </div>
        </div>
    </div>

    <div class="mortality-notes">
        <div class="field-label">Notes:</div>
        <div class="field-value">{{ mortality?.notes || '-' }}</div>
    </div>
</div>
